import { getEventPropsBuilder, toSnakeCase } from '@/tracking/amplitude/utils';
import type { RewardsHubSharedState, RewardsHubTrackSendEvent, PromoBaseContext } from './rewards-hub';
import {
    trackRewardsHubAmplitude,
    getModuleByLocation,
    mapPromoBaseContextToAmplitudeProps,
    mapPositionToAmplitudeProps
} from './rewards-hub';
import { REWARDS_HUB_AMP_EVENT, REWARDS_SOURCE, REWARDS_LINK_TYPE } from './event-names';
import type { PromotionLocation } from '@fanduel/rewards-hub-client';

export type RewardsHubPromoLinkType = (typeof REWARDS_LINK_TYPE)[keyof typeof REWARDS_LINK_TYPE];

export type RewardsHubPromoClickContext = PromoBaseContext & {
    position?: number;
    location?: PromotionLocation;
};

export const trackRewardsHubPromoClickToAmplitude = (args: {
    sendEvent: RewardsHubTrackSendEvent | undefined;
    sharedState?: RewardsHubSharedState | null;
    type: RewardsHubPromoLinkType;
    linkText: string;
    context?: RewardsHubPromoClickContext;
}) => {
    const { sendEvent, sharedState, context, type, linkText } = args;

    const eventProps = getEventPropsBuilder((ctx, linkType, text) => ({
        event: REWARDS_HUB_AMP_EVENT.PROMO_CARD_CLICKED,
        Module: getModuleByLocation(ctx?.location),
        Source: REWARDS_SOURCE.PROMO_HUB,
        ...(ctx?.location ? { Tab: ctx.location } : {}),
        'Link Text': toSnakeCase(text),
        'Link Type': linkType,
        ...mapPromoBaseContextToAmplitudeProps(ctx),
        ...mapPositionToAmplitudeProps(ctx?.position)
    }))(context, type, linkText);

    trackRewardsHubAmplitude({
        sendEvent,
        event: eventProps.event,
        sharedState,
        props: eventProps
    });
};
